module.exports = __webpack_public_path__ + "static/img/322_TO8_2499_og.5e132f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/322_TO8_2499_og.jpg
// module id = iIA7
// module chunks = 0